import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { IIconSwitchOption } from '../../../../core/interfaces/IIconSwitchOption';
import { IPagination } from '../../../../core/interfaces/IPagination';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { IconSwitchComponent } from '../../../../shared/components/icon-switch/icon-switch.component';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';
import { PaginationComponent } from '../../../../shared/components/pagination/pagination.component';
import { SearchComponent } from '../../../../shared/components/search/search.component';
import { TooltipDirective } from '../../../../shared/directives/tooltip.directive';
import { DateFormatPipe } from '../../../../shared/pipes/date-format.pipe';
import { EmptyPipe } from '../../../../shared/pipes/empty.pipe';
import { NumberToCurrencyPipe } from '../../../../shared/pipes/number-to-currency.pipe';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { OnlineOrderStatuses } from '../../core/enums/OnlineOrderStatuses';
import { IOnlineOrder } from '../../core/interfaces/IOnlineOrder';

@Component({
  selector: 'app-online-orders-search',
  standalone: true,
  imports: [
    SearchComponent,
    PaginationComponent,
    TranslatePipe,
    TooltipDirective,
    IconSwitchComponent,
    LoaderComponent,
    DateFormatPipe,
    EmptyPipe,
    NumberToCurrencyPipe,
  ],
  templateUrl: './online-orders-search.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnlineOrdersSearchComponent extends BaseComponent {

  public readonly orders = input.required<IOnlineOrder[]>();
  public readonly status = input.required<OnlineOrderStatuses>();
  public readonly pagination = input.required<IPagination>();
  public readonly isLoading = input(false);

  @Output() statusChange = new EventEmitter<OnlineOrderStatuses>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() pageChange = new EventEmitter<number>();
  @Output() refresh = new EventEmitter<void>();
  @Output() detailsRequested = new EventEmitter<number>();
  @Output() fulfilmentRequested = new EventEmitter<number>();

  public readonly onlineOrderStatuses = OnlineOrderStatuses;

  public readonly statusFilterOptions: IIconSwitchOption<OnlineOrderStatuses>[] = [
    {
      value: OnlineOrderStatuses.Open,
      iconClass: 'ri-time-line',
    },
    {
      value: OnlineOrderStatuses.Issued,
      iconClass: 'ri-check-double-line',
    },
  ];

  /** Like CXCash DlgSelectOnlineOrders: picking an open order goes straight to reading the cards. */
  public onRowClick(order: IOnlineOrder): void {
    if (order.status === OnlineOrderStatuses.Open) {
      this.fulfilmentRequested.emit(order.transactionId);
    } else {
      this.detailsRequested.emit(order.transactionId);
    }
  }

  public onSearchChange(query: string): void {
    this.searchChange.emit(query);
  }
}
